import {Field, type FieldProps, Typography} from "@matillion/component-library";
import {type ChangeEvent, useCallback} from "react";
import Styles from "./CheckboxField.module.scss"

interface Props extends Omit<FieldProps, "value" | "onChange" | "checked" | "type">{
    value: boolean
    setValue: (newValue: boolean) => void
    small?: boolean
    description?: string
    disabled?: boolean
}
export function CheckboxField({value, setValue, small, ...extra}: Props) {
    const onChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.checked)
    }, [setValue])
    if(!small) {
        return <Field {...extra} type="checkbox" checked={value} value={value} onChange={onChange} />
    }
    const {title, description, disabled} = extra
    return <div className={Styles.Field}>
        <div className={Styles.Title}>
            <Typography format="bcs" weight="bold">{title}</Typography>
            <input type="checkbox" disabled={disabled ?? false} checked={value} onChange={onChange} />
        </div>
        {description && <Typography format="bcs">{description}</Typography>}
    </div>
}